import { useCatalogContext } from '../../../../state/Catalog';
import { useCatalogRegistryTranslations } from '../../../../Catalog.i18n';
import { useEffect } from 'react';
import { useGetCatalogProductDetailsQuery } from '@apps/registry/common/components/Catalog/api/queries/getCatalogProductDetails';
import { useCatalogRegistryTelemetry } from '@apps/registry/common/components/Catalog/Catalog.telemetry';
import { useRegistryShopping } from '@apps/registry/admin/RegistryShopping.provider';

export const useQuickAddForm = ({ catalogItemId }: { catalogItemId: Maybe<string> }) => {
  const { catalogProductDetailsQueryError } = useCatalogRegistryTelemetry();
  const { getAddProductTranslations } = useCatalogRegistryTranslations();
  const { notificationText } = getAddProductTranslations();
  const { addCatalogItemToRegistry, notificationVisible, setNotificationVisible } = useCatalogContext();
  const { isEnabled: isShoppingEnabled } = useRegistryShopping();

  const { product, error } = useGetCatalogProductDetailsQuery({
    catalogItemId: catalogItemId!,
    withPdpSections: false,
    withProductRating: false,
    withInventory: isShoppingEnabled,
    queryOptions: {
      batchMode: 'fast',
    },
  });

  useEffect(() => {
    if (error && catalogItemId) {
      catalogProductDetailsQueryError({ catalogItemId, error });
    }
  }, [catalogProductDetailsQueryError, catalogItemId, error]);

  return {
    addCatalogItemToRegistry,
    hasError: !!error,
    notificationText,
    notificationVisible,
    product: product || null,
    setNotificationVisible,
  };
};
